import React from "react";
import Hero from "../components/Hero";
import Winners from "../components/Winners";
import Countdown from "../components/Countdown";
import Cauza from "../components/Cauza";
import HistoryTimeline from "../components/HistoryTimeline";
import SponsorPackages from "../components/SponsorPackages";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import Partners from "../components/Partners";

const Home = () => {
  return (
    <>
      <Hero />
      <Winners />
      <Countdown />
      <Cauza />
      <HistoryTimeline />
      <SponsorPackages />
      <FAQ />
      <Contact />
      <Partners />
    </>
  );
};

export default Home;
